/*
 * GSAP core: registers the plugins the engine needs and exposes the exact
 * easing curves the original template used, so the rebuilt motion matches it.
 */
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CustomEase } from 'gsap/CustomEase'

let registered = false

export const registerGsap = (): void => {
    if (registered || typeof window === 'undefined') return

    gsap.registerPlugin(ScrollTrigger, CustomEase)

    // The template's default "ease" is the CSS ease curve.
    if (!CustomEase.get('mdl-ease')) {
        CustomEase.create('mdl-ease', '0.25, 0.1, 0.25, 1')
    }
    // The "swingFromTo" curve used on the footer email hover.
    if (!CustomEase.get('mdl-swing')) {
        CustomEase.create('mdl-swing', '0.694, 0.0482, 0.335, 1')
    }

    registered = true
}

export { gsap, ScrollTrigger }

// Named eases mirroring the template's defaults.
export const EASE = 'mdl-ease'
export const EASE_SWING = 'mdl-swing'
